import { Box, Card, H2, Separator } from '@betterment/samba-react';

import InvitationListItem from './InvitationListItem';
import { useReferralSenderOffer } from './ReferAFriendProvider';

import { Referral } from '../data';

type GroupRefferalbyStatus = {
  signedUp: Referral[];
  completed: Referral[];
  invited: Referral[];
};

type KeysOfUserReferredStates = keyof GroupRefferalbyStatus;
const groupRefferalbyStatus = (referralInvites: Referral[] | null) => {
  const result: GroupRefferalbyStatus = {
    completed: [],
    signedUp: [],
    invited: [],
  };

  if (!referralInvites) return result;
  referralInvites.forEach(item => {
    switch (item.status) {
      case 'funded':
        result.completed.push(item);
        return;
      case 'signed_up':
        result.signedUp.push(item);
        return;
      case 'prompt':
      case 'sent':
        result.invited.push(item);
    }
  });
  return result;
};

const InvitationListCard: React.FC = () => {
  const { referralInvites } = useReferralSenderOffer();
  const referrals = groupRefferalbyStatus(referralInvites);
  const referralStatues = Object.keys(referrals) as KeysOfUserReferredStates[];
  if (referralInvites.length === 0) return null;

  return (
    <Card css={{ p: 'space.400' }}>
      <Card.Header>
        <H2 variant="title200">Your referred friends</H2>
      </Card.Header>
      <Box css={{ py: 'space.300' }}>
        <Separator />
      </Box>
      <Card.Content>
        {referralStatues.map((referralState, index) => {
          const referralData = referrals[referralState];

          if (referralData.length === 0) return null;
          const isLastItemInList = referralStatues.length === (index += 1);
          const rowTitle = referralState
            .split(/(?=[A-Z])/)
            .join(' ')
            .toUpperCase();

          return (
            <div key={referralState}>
              <InvitationListItem title={rowTitle} referralData={referralData} />
              {!isLastItemInList && (
                <Box css={{ py: 'space.300' }}>
                  <Separator />
                </Box>
              )}
            </div>
          );
        })}
      </Card.Content>
    </Card>
  );
};

export default InvitationListCard;
